import { styled, useTheme } from "@mui/material/styles";

import packageJson from "../../../package.json";

const appVersion = packageJson.version;

const AppVersion = () => {
  const theme = useTheme();

  const AppVersionTextStyled = styled("p")(() => ({
    marginTop: "auto",
    textAlign: "center",
    color: theme.vars.palette.texts.neutral.subtle,
  }));

  return <AppVersionTextStyled>v{appVersion}</AppVersionTextStyled>;
};

export default AppVersion;
